import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import contentRequest from '~/src/api/requests/contentRequest';
import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';
import { billingXMLGetRequest } from '@ertelecom/ui-react/components/requests/billingRequest';
import { BILLING_GET_INFO } from '../constants';
import { EVENTS } from '~/src/constants/analytics';

export function getTvPackets(params) {
    const { cityDomain,
        accessToken,
        channels = 1,
        costRa = 1,
        connectedInTariff = 1,
        connectedOutTariff = 1,
        canConnect = 1 } = params;
    const reqParams = {
        params: {
            channels,
            costRa,
            type: [
                connectedInTariff ? 'connectedInTariff' : '',
                connectedOutTariff ? 'connectedOutTariff' : '',
                canConnect ? 'canConnect' : ''
            ],
        }
    };

    return profileRequest(cityDomain, accessToken).get('/tv-packets', reqParams).then((res) => {
        return res.data;
    }).catch((err) => {
        return err.data;
    });
}

export function packageON({ billingHost, agreement_id, access_token, tr_id, packet, date_to, date_from, close_packet, ra_id }) {
    const data = {
        tr_id,
        packet,
    };

    if (agreement_id) {
 data.agreement_id = agreement_id;
}
    if (date_to) {
 data.date_to = date_to;
}
    if (date_from) {
 data.date_from = date_from;
}
    if (close_packet) {
 data.close_packet = close_packet;
}
    if (ra_id) {
 data.ra_id = ra_id;
}

    return billingXMLGetRequest(billingHost, access_token, BILLING_GET_INFO, 'set_tv_packet', data);
}

export function packageOFF({ billingHost, agreement_id, access_token, tr_id, packet, date_to }) {
    const data = {
        agreement_id,
        tr_id,
        packet,
        date_to,
    };

    return billingXMLGetRequest(billingHost, access_token, BILLING_GET_INFO, 'unset_tv_packet', data);
}

export function GA(data) {
    window.dataLayer = window.dataLayer || [];

    return dataLayerPush({
        event: EVENTS.UAevent,
        category: 'Domru tv',
        ...data,
    });
}

// получение данных для баннера
export const getBanner = (domain) => {
    return contentRequest.getWithCache(`${domain}/v1/content-block?filter[alias]=tv_channel_movix_pro`);
};
